import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Cabecalho,
  ContainerAcoes,
  Filtro,
  IconeEditar,
  TabelaDados,
  TabelaRef,
  TabelaResposta,
  Tooltip,
  Visao
} from 'src/componentes'
import {
  Container,
  Form,
  ContainerDados75,
  Dados
} from 'src/componentes/styles/filtro'
import {
  DataInputUnform,
  InputUnform,
  SelectOpcao,
  SelectUnform
} from 'src/componentes/unform'
import { RotasAlunoCertificacao, RotasTurmaCertificacao } from 'src/rotas'
import { Api } from 'src/servicos'
import { TipoOrdenacao } from 'src/tipos'
import {
  AlunoCertificacaoSituacao,
  DadosPesquisaAlunoCertificacao,
  SituacaoAlunoCertificacao
} from 'src/tipos/aluno-certificacao'

import { ContainerCertificacao } from '../styles'
import { TabelaComEstilos } from './styles'

export const PaginaAlunosCertificacao: React.FC = () => {
  const { visao } = AutenticacaoContainer.useContainer()
  const usuario = localStorage.getItem('@ipgs/usuario')
  const usuarioObj = JSON.parse(usuario)
  const usuarioId = usuarioObj.id

  const history = useHistory()
  const [
    dadosPesquisa,
    definirDadosPesquisa
  ] = useState<DadosPesquisaAlunoCertificacao>(null)
  const tabelaRef = useRef<TabelaRef>()
  const [paginas, definirPaginas] = useState(null)
  const [opcoesTurma, setOpcoesTurma] = useState<SelectOpcao[]>([])
  const [usuarioOpcoes, definirUsuarioOpcoes] = useState<SelectOpcao[]>([])

  const obterDados = async (
    numeroPaginas: number,
    quantidadePorPagina: number,
    chaveOrdenacao?: string,
    ordem?: TipoOrdenacao
  ): Promise<TabelaResposta | null> => {
    if (paginas !== null) numeroPaginas = paginas

    const parametrosComuns = {
      usuarioId,
      visao,
      cpf: dadosPesquisa?.cpf,
      nome: dadosPesquisa?.nome,
      situacao: dadosPesquisa?.situacao,
      turmaCertificacaoId: dadosPesquisa?.turmaCertificacaoId,
      usuarioPerfilFiltro: dadosPesquisa?.usuarioPerfilFiltro,
      dataCriaaoAluno: dadosPesquisa?.dataCriacaoAluno,
      chaveOrdenacao,
      ordem
    }

    const requisitarAlunos = async (
      pagina: number,
      quantidade: number,
      isPaginated: number
    ) =>
      Api.RequisitarListaAlunosCertificacao(
        parametrosComuns.usuarioId,
        parametrosComuns.visao,
        isPaginated,
        parametrosComuns.cpf,
        parametrosComuns.nome,
        null,
        parametrosComuns.situacao,
        parametrosComuns.turmaCertificacaoId,
        parametrosComuns.usuarioPerfilFiltro,
        parametrosComuns.dataCriaaoAluno,
        pagina,
        quantidade,
        parametrosComuns.chaveOrdenacao,
        parametrosComuns.ordem
      )

    const dados = await requisitarAlunos(numeroPaginas, quantidadePorPagina, 1)
    if (!dados) return null

    if (visao !== Visao.ParceiroCertificacao) {
      const dadosTodos = await requisitarAlunos(1, 0, 0)
      const usuariosUnicos = dadosTodos.registros
        .map(dado => ({
          id: dado.usuarioPerfilId,
          texto: dado.usuarioPerfilNome
        }))
        .filter(
          (valor, indice, self) =>
            self.findIndex(v => v.id === valor.id) === indice
        )

      definirUsuarioOpcoes([{ id: '', texto: 'Todos' }, ...usuariosUnicos])
    }

    definirPaginas(null)

    const turmas = await Api.RequisitarTodasTurmasCertificacao(usuarioId, visao)
    setOpcoesTurma([
      { id: '', texto: 'Todas' },
      ...turmas.map((turma: any) => ({ id: turma.id, texto: turma.nome }))
    ])

    return {
      Dados: dados.registros,
      Paginacao: {
        Pagina: dados.opcoesPaginacao.pagina,
        TotalRegistros: dados.opcoesPaginacao.totalRegistros
      }
    } as TabelaResposta
  }

  useEffect(() => {
    if (dadosPesquisa === null) return
    tabelaRef.current.IrParaPagina()
    tabelaRef.current.CarregarDados()
  }, [dadosPesquisa])

  const acaoPesquisa = (dados: DadosPesquisaAlunoCertificacao) => {
    if (dados !== null && paginas !== 1) {
      definirPaginas(1)
    }
    definirDadosPesquisa(dados)
  }

  return (
    <ContainerCertificacao>
      <Cabecalho>
        <Breadcrumb
          titulo="Pesquisa de Alunos"
          atalhos={[
            {
              texto: 'Acadêmico'
            },
            {
              texto: 'Alunos'
            }
          ]}
        />
        {visao === Visao.ParceiroCertificacao && (
          <Botao
            type="button"
            texto="Incluir"
            tema="Secundario"
            onClick={() => history.push(RotasAlunoCertificacao.Cadastro)}
          />
        )}
      </Cabecalho>
      <Filtro>
        <Form
          dadosIniciais={{
            situacao:
              AlunoCertificacaoSituacao[AlunoCertificacaoSituacao.Todos],
            modalidade: 'Todas'
          }}
          acaoSucesso={acaoPesquisa}
        >
          <Container>
            <ContainerDados75>
              <InputUnform type="text" name="cpf" label="CPF" />
            </ContainerDados75>
            <ContainerDados75>
              <InputUnform type="text" name="nome" label="Nome" />
            </ContainerDados75>
            {/* <ContainerDados75>
              <InputUnform type="text" name="email" label="Email" />
            </ContainerDados75> */}
            <ContainerDados75>
              <SelectUnform
                id="slct_alunoTurma"
                name="turmaCertificacaoId"
                label="Turma"
                margemInferior={false}
                opcoes={opcoesTurma}
              />
            </ContainerDados75>
          </Container>
          <Container>
            <ContainerDados75>
              <SelectUnform
                id="slct_status"
                name="situacao"
                label="Situação do Aluno"
                placeholder="Selecione"
                opcoes={[
                  {
                    id:
                      SituacaoAlunoCertificacao[
                        SituacaoAlunoCertificacao.Aprovado
                      ],
                    texto:
                      SituacaoAlunoCertificacao[
                        SituacaoAlunoCertificacao.Aprovado
                      ]
                  },
                  {
                    id:
                      SituacaoAlunoCertificacao[
                        SituacaoAlunoCertificacao.Reprovado
                      ],
                    texto:
                      SituacaoAlunoCertificacao[
                        SituacaoAlunoCertificacao.Reprovado
                      ]
                  },
                  {
                    id:
                      SituacaoAlunoCertificacao[
                        SituacaoAlunoCertificacao.Emandamento
                      ],
                    texto: 'Em andamento'
                  },
                  {
                    id: 'Todas',
                    texto: 'Todas'
                  }
                ]}
              />
            </ContainerDados75>
            {visao !== Visao.ParceiroCertificacao && (
              <ContainerDados75>
                <SelectUnform
                  id="slct_usuario"
                  name="usuarioPerfilFiltro"
                  label="Parceiro"
                  margemInferior={false}
                  opcoes={usuarioOpcoes}
                />
              </ContainerDados75>
            )}
            <ContainerDados75>
              <DataInputUnform
                name="dataCriacaoAluno"
                label="Data de criação"
              />
            </ContainerDados75>
          </Container>
          <Botao
            type="submit"
            id="btn-aplicar-filtro"
            texto="Aplicar filtro"
            tema="Link"
          />
        </Form>
      </Filtro>
      <Dados>
        <TabelaComEstilos
          ref={tabelaRef}
          Colunas={[
            {
              Chave: 'cpf',
              Texto: 'CPF',
              Renderizar: (linha: any) => (linha?.cpf === '' ? '-' : linha.cpf),
              ComOrdenacao: true
            },
            {
              Chave: 'nome',
              Texto: 'Nome',
              ComOrdenacao: true
            },
            {
              Chave: 'turma',
              Texto: 'Turma',
              Renderizar: (linha: any) => linha.turmaAluno.nome ?? '-',
              ComOrdenacao: true
            },
            {
              Chave: 'situacao',
              Texto: 'Situação',
              Renderizar: (linha: any) =>
                linha.situacao === 'Emandamento'
                  ? 'Em andamento'
                  : linha?.situacao ?? '-',
              ComOrdenacao: true
            },
            ...(visao !== Visao.ParceiroCertificacao
              ? [
                  {
                    Chave: 'usuarioPerfilNome',
                    Texto: 'Nome do parceiro',
                    ComOrdenacao: false
                  }
                ]
              : []),
            {
              Chave: 'acoes',
              Alinhamento: 'center',
              Renderizar: (linha: TabelaDados) => (
                <ContainerAcoes>
                  <button
                    type="button"
                    data-tip="Editar"
                    data-for={`${linha.id}-tooltip-editar`}
                    onClick={() =>
                      history.push(
                        `${RotasAlunoCertificacao.Edicao}/${linha.id}`,
                        {
                          modalidade: linha.modalidade
                        }
                      )
                    }
                    onContextMenu={() => {
                      const rota = window.open(
                        `${RotasTurmaCertificacao.Edicao}/${linha.id}/${linha.modalidade}`
                      )
                      rota.focus()
                    }}
                  >
                    {IconeEditar}
                  </button>
                  <Tooltip
                    id={`${linha.id}-tooltip-editar`}
                    place="bottom"
                    offset={{ top: 10 }}
                  />
                </ContainerAcoes>
              )
            }
          ]}
          ObterDados={obterDados}
          ComPaginacao
        />
      </Dados>
    </ContainerCertificacao>
  )
}

export { default as PaginaCadastroAlunosCertificacao } from './cadastro'
